<template>
  <div id="app" class="font-SanFrancisco">
    <!--VApp - Vuetify -->
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Hệ thống quản lý | Lê Phong Mobile",
      meta: [
        {
          name: "description",
          content: "Hệ thống quản lý phòng khám Lê Phong Mobile",
        },
        {
          property: "og:title",
          content: "Hệ thống quản lý | Lê Phong Mobile",
        },
        { property: "og:site_name", content: "Epiloge" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style lang="scss">
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
}
.theme--dark.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.5);
}
@font-face {
  font-family: "SanFrancisco-Bold";
  font-weight: 700;
  src: url(./assets/fonts/SanFrancisco/WOFF/SanFranciscoDisplay-Bold.woff) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "Mabella";
  font-weight: 700;
  src: url(./assets/fonts/SanFrancisco/WOFF/SVN-Mabella.woff) format("woff");
  font-display: swap;
}

@font-face {
  font-family: "SanFrancisco";
  font-weight: 500;
  src: url(./assets/fonts/SanFrancisco/WOFF/SanFranciscoDisplay-Medium.woff)
    format("woff");
  font-display: swap;
}

@font-face {
  font-family: "SanFrancisco";
  font-weight: 400;
  src: url(./assets/fonts/SanFrancisco/WOFF/SanFranciscoDisplay-Medium.woff)
    format("woff");
  font-display: swap;
}
#app {
  font-family: "SanFrancisco";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.toasted {
  border-radius: 5px !important;
}
.action {
  &.ripple {
    color: transparent !important;
    text-shadow: 0 0 0 white !important;
    &:hover {
      text-decoration: none !important;
    }
  }
}
.v-data-table {
  overflow-x: auto;
}
.truncate {
  max-width: 10vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.container {
  margin: 0px;
  padding: 0px;
  width: 100% !important;
}
</style>
